export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-08.jpg'),
        title: 'BUSINESS PROCESS OUTSOURCING',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: 'BPO ADVANTAGES OF BUSINESS PROCESS OUTSOURCING',
      description: `<p style="font-size:1.5rem">
      At present, economic globalization is entering a new stage of development. Global industrial transfer extends from manufacturing industry to service industry. Service outsourcing has become an important trend in the development of service industry globalization.
By using BPO mode, the enterprise will subcontract its auxiliary business to a professional and experienced third-party company, which will enhance the competitive advantage of its main business.
      </p>
      <p>
      BPO is applicable to all industries BPO helps accelerate the development of enterprises. Effectively improves the supporting role of ancillary business to core business and increases overall profit Enterprises further highlight the key management of core business, while achieving effective control of ancillary business
 It helps break the traditional industry boundary in the new market environment, forming cross-business alliances with external companies, forming long-term strategic partnerships and enhancing their competitiveness. Helps control and reduce the production cost of enterprises.
      </p>`
    },
    {
      title: 'OUR SERVICES AND ADVANTAGES',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-08.jpg')+`)"></span>
      <span class="list">
      <i></i>Long-term accumulated outsourcing service experience, according to the actual situation of customers<br/>
      <i></i>Combined with national policies, to develop the best program for customers.<br/>
      <i></i>Enhancing management efficiency in an all-round way<br/>
      <i></i>Assisting enterprises in cost control<br/>
      <i></i>Assisting enterprises upgrade their core business capabilities
      </span>`
    }
  ]
}
